import styled from "styled-components";

export const Container = styled.div `
    
`

export const Title = styled.h4 `
    font-weight: 550;
    font-size: 1.89rem;
    line-height: 50px;
    color: ${props => props.theme.colors.typography1.pure};
    margin-bottom: 32px;

    @media(min-width: 768px){
        font-size: 1.25rem;
        line-height: 25px;
        margin-bottom: 16px;
    }
`

export const InsertProducts = styled.button `
    margin-bottom: 32px;
    border-radius: 14px;

    font-weight: 550;
    font-size: 1rem;
    line-height: 30px;
    border: 1px solid ${(props) => props.theme.colors.brand1.pure};
    color: ${(props) => props.theme.colors.brand1.pure};
    background-color: transparent;

    @media(min-width: 768px){
        font-size: 1rem;
        line-height: 16px;
        height: 35px;
        margin-bottom: 16px;
    }
    
`

export const UserWishlistItems = styled.ul `
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-column: 1 / 3;
    gap: 24px;

    @media(min-width: 768px){
        gap: 8px;
        overflow-y: auto;
        max-height: 380px;

        ::-webkit-scrollbar{
            width: 8px;
            background-color: ${props => props.theme.colors.brand4.dark};
            border-radius: 4px;
        }

        ::-webkit-scrollbar-thumb{
            border-radius: 4px;
            background-color: ${props => props.theme.colors.brand1.pure};
        }
    }
`

export const IsEmptyMessage = styled.h2 `
    text-align: center;
    font-weight: 550;
    font-size: 1.8rem;
    line-height: 50px;
    color: ${props => props.theme.colors.typography1.pure};

    @media(min-width: 768px){
        font-size: 1.25rem;
        line-height: 25px;
    }
    @media(max-width: 767px){
        background-color: ${props => props.theme.colors.typography3.dark};
        padding: 16px;
        border-radius: 16px;
    }
`